import { useRef } from "react";
import { Form } from "react-bootstrap";
import { Col, FormGroup, Input, Row } from "reactstrap";
import { InputFile } from "../../../../shared/components/InputFile";
import { placeholderText } from "../../../../shared/helpers/placeHolders";
import { ResponseType } from "../../../../shared/model/enumerations/response-type.model";
import { IQuestion } from "../../../../shared/model/IQuestions";
import { yesNoEnum } from "../../../../shared/selectors/yesNoEnum";

interface IProps {
  currentQuestion: IQuestion;
  formik: any;
}
export const BodyModal = (props: IProps) => {
  const { currentQuestion, formik } = props;
  const fileRef = useRef<HTMLInputElement>(null);

  return (
    <Form>
      {currentQuestion?.currentQuestion &&
        formik.values.candidateQuestionResponses[currentQuestion.current] && (
          <Row>
            <Col className="column-questions">
              {currentQuestion.currentQuestion.responseType ===
                ResponseType.YES_NO && (
                <>
                  {yesNoEnum().map((el, index) => (
                    <Row key={index} className="mt-3 mx-1">
                      <Form.Check
                        className="check-radio"
                        checked={
                          formik.values.candidateQuestionResponses[
                            currentQuestion.current
                          ].response === el.value
                        }
                        onChange={() =>
                          formik.setFieldValue(
                            `candidateQuestionResponses[${currentQuestion.current}].response`,
                            el.value
                          )
                        }
                        inline
                        label={el.label}
                        name={`candidateQuestionResponses[${currentQuestion.current}].response`}
                        type="radio"
                      />
                    </Row>
                  ))}
                </>
              )}
              {currentQuestion.currentQuestion.responseType ===
                ResponseType.ATTACH_FILE && (
                <Row className="mt-5 container-inputs-form">
                  <InputFile
                    formik={formik}
                    title={""}
                    nameFile={`candidateQuestionResponses[${currentQuestion.current}].file`}
                    defaultValue={
                      formik.values?.candidateQuestionResponses[
                        currentQuestion.current
                      ]?.file
                        ? formik.values?.candidateQuestionResponses[
                            currentQuestion.current
                          ]?.file
                        : ""
                    }
                    refInput={fileRef}
                    nameProp={`candidateQuestionResponses[${currentQuestion.current}]`}
                  />
                </Row>
              )}
              {currentQuestion.currentQuestion.responseType ===
                ResponseType.FREE_TEXT && (
                <Row className="mt-5 container-inputs-form">
                  <Col>
                    <FormGroup>
                      <Input
                        type="textarea"
                        name={`candidateQuestionResponses[${currentQuestion.current}].response`}
                        value={
                          formik.values.candidateQuestionResponses[
                            currentQuestion.current
                          ].response
                        }
                        onChange={formik.handleChange(
                          `candidateQuestionResponses[${currentQuestion.current}].response`
                        )}
                        placeholder={placeholderText()}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              )}
              {currentQuestion.currentQuestion.responseType ===
                ResponseType.LINK && (
                <Row className="mt-5 container-inputs-form">
                  <Col>
                    <FormGroup>
                      <Input
                        type="text"
                        name={`candidateQuestionResponses[${currentQuestion.current}].response`}
                        value={
                          formik.values.candidateQuestionResponses[
                            currentQuestion.current
                          ].response
                        }
                        onChange={formik.handleChange(
                          `candidateQuestionResponses[${currentQuestion.current}].response`
                        )}
                        placeholder={placeholderText()}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        )}
    </Form>
  );
};
